import {
  SubscriptionException,
} from '@/domain/stripe/customer/sub-domains/subscription/model/exception/SubscriptionException'

export class InvalidSubscriptionException extends SubscriptionException {

}
